import { Box, Typography } from '@mui/material';
import { type TRPCClientErrorBase } from '@trpc/client';
import { type TRPCDefaultErrorShape } from '@trpc/server';
import { type OptionsWithExtraProps } from 'notistack';
import { Link } from 'react-router';

import { url } from '../../appRouter/url';
import { type AkaVeranstaltungId } from '../../dtos';
import { type SnackbarGenerator } from './snackbars.types';

const createVeranstaltungSnackbarErrorOptions: OptionsWithExtraProps<'error'> = {
  variant: 'error',
  persist: true,
};

export const generateCreateVeranstaltungErrorSnackbar: SnackbarGenerator<TRPCClientErrorBase<TRPCDefaultErrorShape>> = (
  error,
) => ({
  message: 'Fehler beim Speichern der Veranstaltung',
  options: {
    ...createVeranstaltungSnackbarErrorOptions,
    additional: error.message,
  },
});

export const generateCreateVeranstaltungErrorSnackbarWithFehlerId: SnackbarGenerator<{
  error: TRPCClientErrorBase<TRPCDefaultErrorShape>;
  fehlerId: string;
}> = ({ error, fehlerId }) => ({
  message: 'Fehler beim Speichern der Veranstaltung',
  options: {
    ...createVeranstaltungSnackbarErrorOptions,
    additional: (
      <div>
        <p>Es trat ein Fehler beim Speichern der Veranstaltung auf. Wende dich bitte mit Fehler-ID</p>
        <p>{fehlerId}</p>
        <p>an das VAMOS Team.</p>
        <p>{error.message}</p>
      </div>
    ),
  },
});

export const generateCreateVeranstaltungSuccessSnackbar: SnackbarGenerator<AkaVeranstaltungId> = (
  akaVeranstaltungId,
) => ({
  message: 'Veranstaltung gespeichert',
  options: {
    variant: 'success',
    additional: (
      <Box>
        <Typography component="span">Veranstaltung mit ID </Typography>
        <Link to={url.veranstaltung.details(akaVeranstaltungId)} target="_blank" rel="noopener">
          {akaVeranstaltungId}
        </Link>
        <Typography component="span"> wurde erfolgreich gespeichert!</Typography>
      </Box>
    ),
  },
});

export const generateKurzfristigerErsatzterminInfoSnackbar: SnackbarGenerator<AkaVeranstaltungId> = (
  akaVeranstaltungId,
) => ({
  message: 'Kurzfristiger Ersatztermin',
  options: {
    variant: 'info',
    persist: true,
    additional: (
      <Box>
        <Typography component="span">Veranstaltung mit ID </Typography>
        <Link to={url.veranstaltung.details(akaVeranstaltungId)} target="_blank" rel="noopener">
          {akaVeranstaltungId}
        </Link>
        <Typography component="span">
          &nbsp; ist ein Ersatztermin mit Start in bis zu 11 Tagen. Gib die Veranstaltung direkt frei und erstelle das
          Angebot im Ausschreibungsportal.
        </Typography>
      </Box>
    ),
  },
});
